import styled from "@emotion/styled"
import { Box, Dialog, DialogContent, Grid, IconButton, Typography, useTheme } from "@mui/material"
import AppDatePicker from "components/AppDatePicker"
import ImageUploadField from "components/FileUpload/ImageUploadField"
import ImageCropper from "components/ImageCropper"
import AppButton from "components/StyledComponents/AppButton"
import AppTextArea from "components/StyledComponents/AppTextArea"
import AppTextField from "components/StyledComponents/AppTextField"
import MultipleSelect from "components/StyledComponents/MultipleSelect"
import StyledLabel from "components/StyledComponents/StyledLabel"
import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import CloseIcon from "@mui/icons-material/Close"
import { useDispatch, useSelector } from "react-redux"
import { uploadNotificationImageAction } from "redux/superAdmin/actions/user"

const buttonText = {
  EDIT: "Update",
  SAVE: "Save Changes",
  CANCEL: "Cancel"
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent",
    maxWidth: 800,
    width: "100%"
  },
  "& .MuiDialogContent-root": {
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    border: "none",
    width: "100%",
    padding: 16,
    boxSizing: "border-box"
  }
}))

const CreateAdvertisement = ({ formik, open = false, onClose = () => {}, isEdit = false }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const [uploadType, setUploadType] = useState("")
  const [openCrop, setCrop] = useState(false)
  const [fileDetails, setFileDetails] = useState(null)
  const [imageObjectURL, setImageObjectUrl] = useState(null)
  const [restaurantsList, setRestaurantsList] = useState([])
  const { restaurantList: restaurants } = useSelector((store) => store.user)

  const styles = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: theme.palette.background.main
    }
  }

  const handleImageDelete = (formik) => {
    formik.setFieldValue("image", null)
  }
  const onImageUpload = (image) => {
    setUploadType("")
    if (image) {
      setUploadType("image")
      setCrop(true)
      setFileDetails(image)
      setImageObjectUrl(URL.createObjectURL(image))
    }
  }

  function handleCroppedImage(image, formik) {
    if (uploadType === "image") {
      let data = new FormData()
      data.append("media", image)
      data.append("media_type", "IMAGE")
      data.append("content_type", image.type)
      formik.setFieldValue("image", image)
      dispatch(uploadNotificationImageAction(data))
      setUploadType("")
    }
  }

  function showCropperModal(imageObjectURL, fileDetails, formik) {
    return (
      <ImageCropper
        setSelectedImage={(image) => handleCroppedImage(image, formik)}
        srcImage={imageObjectURL}
        fileDetail={fileDetails}
        aspectRatio={uploadType === "image" && 1}
        onClose={setCrop}
        openCrop={openCrop}></ImageCropper>
    )
  }

  useEffect(() => {
    const allKeyPair = [
      ...(restaurants
        ? restaurants.map((res) => ({
            value: res.id,
            label: res.name
          }))
        : [])
    ]
    setRestaurantsList(allKeyPair)
  }, [restaurants])

  return (
    <StyledDialog open={open}>
      <DialogContent>
        {showCropperModal(imageObjectURL, fileDetails, formik)}
        <Box className="d-flex justify-content-end">
          <IconButton onClick={() => onClose()} sx={styles.closeBtn}>
            <CloseIcon sx={{ height: "14px", width: "14px" }} />
          </IconButton>
        </Box>
        <Box className="w-100 d-flex justify-content-center mb-2">
          <Typography variant="h2"> {isEdit ? "Edit" : "Add New"} Banner</Typography>
        </Box>

        <Box flexDirection="column" className="mt-4">
          <React.Fragment>
            <Box className=" w-100 py-2">
              <Row className="w-100 m-0">
                <Col lg="6">
                  <AppTextField
                    id="heading"
                    name="heading"
                    isUpperCase={!false}
                    type="text"
                    fullWidth
                    label="Banner Heading"
                    isRequired={true}
                    placeholder="Enter Banner Heading"
                    value={formik.values.heading}
                    onChange={formik.handleChange}
                    error={formik.touched.heading && Boolean(formik.errors.heading)}
                    helperText={formik.touched.heading && formik.errors.heading}
                  />
                </Col>
                <Col lg="6">
                  <AppTextField
                    id="tile_heading"
                    name="tile_heading"
                    isUpperCase={!false}
                    type="text"
                    fullWidth
                    label="Tile Heading"
                    isRequired={true}
                    placeholder="Enter Tile Heading"
                    value={formik.values.tile_heading}
                    onChange={formik.handleChange}
                    error={formik.touched.tile_heading && Boolean(formik.errors.tile_heading)}
                    helperText={formik.touched.tile_heading && formik.errors.tile_heading}
                  />
                </Col>
              </Row>
              <Row className="w-100 m-0 mt-4">
                <Col lg="6">
                  <AppTextField
                    id="drawer_title"
                    name="drawer_title"
                    isUpperCase={!false}
                    type="text"
                    fullWidth
                    label="Drawer Title"
                    isRequired={true}
                    placeholder="Enter Drawer Title"
                    value={formik.values.drawer_title}
                    onChange={formik.handleChange}
                    error={formik.touched.drawer_title && Boolean(formik.errors.drawer_title)}
                    helperText={formik.touched.drawer_title && formik.errors.drawer_title}
                  />
                </Col>
                <Col lg="6">
                  <ImageUploadField
                    label="Upload Background"
                    isRequired={true}
                    isVariant={true}
                    placeholder="Upload Background Image"
                    value={formik.values.image}
                    onChange={(e) => onImageUpload(e)}
                    onDelete={() => handleImageDelete(formik)}
                    error={formik.errors.image}
                    touched={formik.touched.image}
                  />
                </Col>
              </Row>
              <Row className="w-100 m-0 mt-4">
                <Col lg="6">
                  <Row className="w-100 m-0">
                    <Col lg="6" className="p-0">
                      <Grid item sm={12} lg={6} className="datesContainer" mr={1}>
                        <StyledLabel variant="body1Regular">
                          {"Ad Start Date"}
                          <span>*</span>
                        </StyledLabel>
                        <Box className="dateFieldContainer w-100 mt-2">
                          <AppDatePicker
                            minDate={new Date()}
                            maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                            inputFormat="dd MMM yyyy"
                            disableMaskedInput
                            key={"ad_start_date"}
                            value={formik.values.ad_start_date}
                            onChange={(val) => formik.setFieldValue("ad_start_date", val)}
                            error={formik.errors.ad_start_date}
                            touched={formik.touched.ad_start_date}
                          />
                        </Box>
                      </Grid>
                    </Col>
                    <Col lg="6" className="p-0">
                      <Grid item sm={12} lg={6} className="datesContainer" ml={1}>
                        <StyledLabel variant="body1Regular">
                          {"Ad End Date"}
                          <span>*</span>
                        </StyledLabel>
                        <Box className="dateFieldContainer w-100 mt-2">
                          <AppDatePicker
                            minDate={new Date()}
                            maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                            inputFormat="dd MMM yyyy"
                            disableMaskedInput
                            key={"ad_end_date"}
                            value={formik.values.ad_end_date}
                            onChange={(val) => formik.setFieldValue("ad_end_date", val)}
                            error={formik.errors.ad_end_date}
                            touched={formik.touched.ad_end_date}
                          />
                        </Box>
                      </Grid>
                    </Col>
                  </Row>
                </Col>
                <Col lg="6">
                  <Row className="w-100 m-0">
                    <Col lg="6" className="p-0">
                      <Grid item sm={12} lg={6} className="datesContainer" mr={1}>
                        <StyledLabel variant="body1Regular">
                          {"Event Start Date"}
                          <span>*</span>
                        </StyledLabel>
                        <Box className="dateFieldContainer w-100 mt-2">
                          <AppDatePicker
                            minDate={new Date()}
                            maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                            inputFormat="dd MMM yyyy"
                            disableMaskedInput
                            key={"start_date"}
                            value={formik.values.start_date}
                            onChange={(val) => formik.setFieldValue("start_date", val)}
                            error={formik.errors.start_date}
                            touched={formik.touched.start_date}
                          />
                        </Box>
                      </Grid>
                    </Col>
                    <Col lg="6" className="p-0">
                      <Grid item sm={12} lg={6} className="datesContainer" ml={1}>
                        <StyledLabel variant="body1Regular">
                          {"Event End Date"}
                          <span>*</span>
                        </StyledLabel>
                        <Box className="dateFieldContainer w-100 mt-2">
                          <AppDatePicker
                            minDate={new Date()}
                            maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                            inputFormat="dd MMM yyyy"
                            disableMaskedInput
                            key={"end_date"}
                            value={formik.values.end_date}
                            onChange={(val) => formik.setFieldValue("end_date", val)}
                            error={formik.errors.end_date}
                            touched={formik.touched.end_date}
                          />
                        </Box>
                      </Grid>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="w-100 m-0 mt-4">
                <Col lg="6">
                  <MultipleSelect
                    id="restaurants"
                    name="restaurants"
                    menuItems={restaurantsList}
                    label="Restaurants"
                    isRequired={true}
                    value={formik.values?.restaurants}
                    onChange={formik.handleChange}
                    error={formik.touched.restaurants && formik.errors.restaurants}
                    touched={formik.touched.restaurants}
                  />
                </Col>
              </Row>
              <Row className="w-100 m-0 mt-4">
                <Col lg="12">
                  <AppTextArea
                    label="Additional Details"
                    minRows={1}
                    maxRows={5}
                    placeholder="Enter Additional Details"
                    value={formik.values.details}
                    onChange={formik.handleChange("details")}
                    error={formik.errors?.details}
                    touched={formik.touched?.details}
                    charLimit={100}
                  />
                </Col>
              </Row>
            </Box>
          </React.Fragment>
        </Box>
        <Box className="mt-4 d-flex justify-content-end">
          <AppButton
            onClick={formik.handleSubmit}
            sx={() => ({
              height: "48px",
              padding: "10px 50px"
            })}>
            {isEdit ? buttonText.EDIT : buttonText.SAVE}
          </AppButton>
        </Box>
      </DialogContent>
    </StyledDialog>
  )
}

export default CreateAdvertisement
